import React from "react";
import CompanySiteTabs from "../../../components/CompanyManagement/Company/Tab Pages/CompanySiteTabs";
import ContentPage from "../../../components/ContentPage";
import { TITLE_COMPANY_MANAGEMENT } from "../../../components/CompanyManagement/CompanyManagementSearchArea";

const CompanySelecting = () => (
  <ContentPage title={TITLE_COMPANY_MANAGEMENT}>
    <CompanySiteTabs defaultTab={0} />
  </ContentPage>
);

export default CompanySelecting;
